// -- todo - base service class
import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class ExternalAuthProviderService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	/**
	 * Get the ID of the org's current authProvider, if it exists
	 * @param {string} orgId -- Organization id
	 * @param {function} callback
	 */
	getAuthByOrgId(orgId, callback) {
		const url = `/ecosystem/api/externalAuthProviders/method/${orgId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Query an LDAP or Active Directory system via connection information and return a list of users for a particular group,
	 *   returning the correct information based on an initial query or an update query
	 * @param {string} host -- LDAP/AD hostname
	 * @param {string} port -- LDAP/AD port
	 * @param {string} username -- LDAP/AD login username
	 * @param {string} password -- LDAP/AD password
	 * @param {string} groupName -- LDAP/AD group name or distinguished name (dn)
	 * @param {string} baseDN -- LDAP/AD baseDN (ex "dc=myCoolSystem,dc=com")
	 * @param {string} authType -- "system", "ldap", or "active-directory"
	 * @param {boolean} update -- update LDAP/AD data or query it for the first time
	 * @param {function} callback
	 */
	testAuthConnection(host, port, username, password, groupName, baseDN, authType, update, callback) {
		const body = JSON.stringify({
			host,
			port,
			username,
			password,
			groupName,
			baseDN,
			authType,
			update
		});
		const url = "/ecosystem/api/externalAuthProviders/connection";
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Add an authProvider entry for the organization and attempt add users to DB
	 * @param {string} orgId -- Organization id
	 * @param {object} connectionData -- hostname, port, username, password, groupName, baseDN, authType
	 * @param {array} users -- list of users to create
	 * @param {function} callback
	 */
	createAuthenticationInfo(orgId, connectionData, users, callback) {
		const url = "/ecosystem/api/externalAuthProviders/method";
		const body = JSON.stringify({
			orgId,
			connectionData,
			users
		});

		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Update an authProvider entry for the organization and attempt to update/create users based on current AD or LDAP
	 * @param {string} orgId -- Organization id
	 * @param {object} connectionData -- hostname, port, username, password, groupName, baseDN, authType
	 * @param {array} users -- list of users to create
	 * @param {string} authId -- Org's current authProvider id
	 * @param {function} callback
	 */
	updateAuthenticationInfo(orgId, connectionData, users, authId, callback) {
		const url = "/ecosystem/api/externalAuthProviders/method/update";
		const body = JSON.stringify({
			orgId,
			connectionData,
			users,
			authId
		});

		this._restClient.exec_post(url, body, callback);
	}

	bulkSaveAuthenticationInfo(data, callback) {
		const url = `/ecosystem/api/externalAuthProviders/bulkSave`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}
}
